import styled from 'styled-components';
import { animated } from '@react-spring/web';
export const Nav = styled.div `
  background-color: #151419;
  color: var(--text-color-0);
  border-color: var(--border-color);
  --ggs: 1.1;
  -webkit-app-region: drag;

  i {
    cursor: pointer;
  }

  @apply box-border flex flex-col items-center justify-between w-20 h-full border-r-1 text-color-white gap-8 py-4;

  [data-role='menu-item'] {
    @apply p-0 flex justify-center items-center h-11 rounded-lg;
  }

  [data-role='layout-nav-top'] {
    @apply flex flex-col items-center gap-8;
  }

  [data-role='menu'] {
    @apply pt-0;
  }

  [aria-selected='false'] {
    color: var(--text-color-2);
  }
`;
export const Main = styled.main `
  @apply flex-1 flex flex-col overflow-hidden;
  background-color: var(--bg-color-1);
`;
export const Content = styled.section `
  background-color: var(--bg-color-1);

  @apply flex w-full h-full box-border flex-col overflow-auto p-4;
`;
export const Aside = styled.aside `
  transform-origin: 0% 50%;
  width: fit-content;
  border-right: ${(props) => props.theme.border.borderRight};
  background-color: var(--bg-color);
  [data-role='aside-inner'] {
    @apply w-full h-full overflow-auto;
    will-change: width;
  }
`;
// TODO: should fix background-color in light theme
export const AsideInner = styled(animated.div) `
  @apply inline-block w-full flex flex-col items-center justify-start;
`;
export const StyledLayout = styled.article `
  @apply flex w-full h-full;
  [data-role='toolbar'] {
    @apply relative z-10;
  }
`;
